import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { IconSetService } from '@coreui/icons-angular';
import { T2dToastService } from '@tec2date/ui-components';
import { routes } from './app.routes';
import { apiInterceptor } from './interceptor/api.interceptor';
import { AuthService } from './services/auth.service';
import { BootstrapService } from './services/bootstrap.service';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

function initializeAuth(authService: AuthService) {
  return () => authService.initializeAuth();
}

function initializeBootstrap(bootstrapService: BootstrapService) {
  return () => {
    bootstrapService.ensureAdmin().subscribe({
      error: () => {
        /* fire-and-forget: App-Start nie blockieren */
      },
    });
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
    ),
    provideHttpClient(withXhr(), withInterceptors([apiInterceptor])),
    IconSetService,
    T2dToastService,
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    // Default-Format der DatePipe — `{{ value | date }}` ohne Format-Argument
    // liefert TT.MM.JJJJ statt der Locale-Default-Kurzform „06.05.26".
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'dd.MM.yyyy' } },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBootstrap,
      deps: [BootstrapService],
      multi: true,
    },
  ],
};
